import React from "react";
import { useLang } from "../../context/LanguageContext";
import { ArrowDownRight } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1483366774565-c783b9f70e2c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export default function Hero() {
  const { t } = useLang();
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative isolate overflow-hidden bg-ink-900 text-cream-100"
    >
      {/* Background image with overlay */}
      <div className="absolute inset-0 z-0 bg-ink-900">
        <img
          src={HERO_IMG}
          alt=""
          className="h-full w-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-ink-900" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 pt-32 md:pt-40 pb-24 md:pb-32 relative z-10">
        <div
          data-testid="hero-overline"
          className="font-mono text-[11px] sm:text-xs uppercase tracking-[0.3em] text-cream-100/70 mb-10 animate-fade-in"
        >
          {t.hero.overline}
        </div>

        <h1
          data-testid="hero-title"
          className="font-serif font-medium tracking-tight leading-[0.95] text-[2.75rem] sm:text-6xl md:text-7xl lg:text-[7.5rem] max-w-5xl text-balance animate-fade-up"
        >
          <span className="block">{t.hero.title_a}</span>
          <span className="block text-cream-100/75">{t.hero.title_b}</span>
          <span className="block italic text-crimson-light">{t.hero.title_c}</span>
        </h1>

        <div className="mt-14 md:mt-20 grid md:grid-cols-12 gap-8 md:gap-16">
          <div className="md:col-span-5 md:col-start-1">
            <div className="border-l-2 border-crimson pl-5">
              <p className="font-serif italic text-base md:text-lg text-cream-100/85 leading-relaxed">
                {t.hero.quote}
              </p>
            </div>
          </div>
          <p
            data-testid="hero-lead"
            className="md:col-span-6 md:col-start-7 text-base md:text-lg leading-relaxed text-cream-100/80 max-w-xl"
          >
            {t.hero.lead}
          </p>
        </div>

        <div className="mt-12 md:mt-16 flex flex-wrap gap-4">
          <a
            href="#contact"
            data-testid="hero-cta-primary"
            className="group inline-flex items-center gap-3 px-6 py-3.5 bg-cream-100 text-ink-900 hover:bg-crimson hover:text-cream-100 transition-colors text-sm font-medium tracking-wide"
          >
            {t.hero.cta_primary}
            <ArrowDownRight size={16} className="transition-transform group-hover:translate-x-0.5 group-hover:translate-y-0.5" />
          </a>
          <a
            href="#practice"
            data-testid="hero-cta-secondary"
            className="inline-flex items-center gap-3 px-6 py-3.5 border border-cream-100/30 text-cream-100 hover:border-cream-100 transition-colors text-sm font-medium tracking-wide"
          >
            {t.hero.cta_secondary}
          </a>
        </div>
      </div>

      <div className="h-px w-full bg-cream-100/10" />
    </section>
  );
}
